module.exports = "@media (max-width: 400px) {\r\n    .checkbox-text {\r\n        width: 80%;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel-default/events-travel-default.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel-default/events-travel-default.component.css
// module chunks = main